module.exports = __webpack_public_path__ + "static/fipcpinkcloudmain-4718b01bff7f4a26f102488ccfa36d3a.jpeg";